import {
  breaksFieldGroupValidator,
  dateRangeFieldGroupUtils,
  dateRangeFieldGroupValidator,
  notesFieldValidator,
  roleFieldValidator,
} from 'element';
import { CreateFormFields } from './createFormFields';

export const validate = (formFields: CreateFormFields) => ({
  ...roleFieldValidator(formFields),
  ...dateRangeFieldGroupValidator(formFields),
  ...(dateRangeFieldGroupUtils.isValidDateRangeGuard(formFields) &&
    breaksFieldGroupValidator(
      formFields,
      dateRangeFieldGroupUtils.getDateRange(formFields)
    )),
  ...notesFieldValidator(formFields),
});

export default validate;
